import logo from './logo.svg';
import './App.css';
import React, { Component } from "react";
import { AppBar } from '@mui/material';
import AppHeader from './AppHeader';
import {Box} from '@mui/material';
import Main, { Mainc } from './Main';
import Secondpage, { Secondpagec } from './Secondpage';
import VendorDescription, { VendorDescriptionc } from './VendorDescription';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Footer from './Footer';

/////// footer assets and section here :-
import About from '../src/footer/About'
import Blogs from '../src/footer/Blogs'
import Career from '../src/footer/Career'
import Community from '../src/footer/Community'
import Contactus from '../src/footer/Contactus'
import Faqs from '../src/footer/Faqs'
import Investers from '../src/footer/Investors'
import Media from '../src/footer/Media'
import Privacy from '../src/footer/Privacy'
import Schlorship from '../src/footer/Schlorship'
import Terms_and_conditon from '../src/footer/Terms_and_conditon'
import Franchise from '../src/footer/Franchise'
import Login from './Login';
import Registration from './Registration';
import Vendor_form from './Vendor_form'
import Frenchise_form from './Frenchise_form';





const router = createBrowserRouter([
  {
    path: "/",
    element: <Mainc />,
  },
    {
    path: "/venderList",
    element: <Secondpagec/>,
  },
    {
    path: "/venderDesc/:id",
    element: <VendorDescriptionc />,
  },
      {
    path: "/login",
    element: <Login />,
  },
      {
    path: "/register",
    element: <Registration />,
  },
 


  ////////// footers
    {
    path: "/contact",
    element: <Contactus/>,
  },
  {
    path: "/blog",
    element: <Blogs/>,
  },
    {
    path: "/franchise",
    element: <Franchise/>,
  },
  {
    path: "/career",
    element: <Career/>,
  },
  {
    path: "/contact",
    element: <Contactus/>,
  },
  {
    path: "/media",
    element: <Media/>,
  },
  {
    path: "/faq",
    element: <Faqs/>,
  },
  {
    path: "/about",
    element: <About/>,
  },
  {
    path: "/community",
    element: <Community/>,
  },
  {
    path: "/investors",
    element: <Investers/>,
  },
  {
    path: "/privacy",
    element: <Privacy/>,
  },

  {
    path: "/termsAndCondition",
    element: <Terms_and_conditon/>,
  },
  


  

    {
    path: "/apply_vendor_registration",
    element: <Vendor_form/>,
  },
  {
    path: "/apply_frenchise_registration",
    element: <Frenchise_form/>,
  },

]);




function App() {
  return (
    <div>   
      
      <AppHeader/>
      <Box sx={{backgroundColor:'#fafafc',mt:1}}>

        <React.StrictMode>
          <RouterProvider router={router} /> 
            <Footer/>
        </React.StrictMode>

  

      </Box>
     

    </div>
  );
}

export default App;
